import * as CryptoJS from 'crypto-js'

export const generateHash = (
  userId: string,
  apiKey: string
): string => {
  var hash = CryptoJS.HmacSHA256(userId, apiKey);
  return CryptoJS.enc.Hex.stringify(hash);
};
